export const THEME = {
  light: 'light',
  dark: 'dark'
};

export const THEMES = [THEME.light, THEME.dark];
